import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import LoadingSpinner from '../components/LoadingSpinner/LoadingSpinner';
import { HOME_PAGE_URL } from '../constants/systemConstants';

/**
 * Route guard for creator-only pages
 * Redirects non-creators to the home page
 * 
 * @param {Object} props
 * @param {React.ReactNode} props.children - The component to render if user is a creator
 * @param {string} props.feature - Optional specific feature to check from accessSpec
 */
const CreatorRoute = ({ children, feature = null }) => {
  const { currentUser, loading } = useAuth();
  
  if (loading) {
    return (
      <LoadingSpinner 
        fullPage 
        size={40}
        text="Loading..."
      />
    );
  }
  
  // Check if user is a creator (API returns 'creator', not 'isCreator')
  if (!currentUser?.creator) {
    return <Navigate to={HOME_PAGE_URL} replace />;
  }
  
  // If a specific feature is required, check accessSpec
  if (feature && currentUser?.accessSpec) {
    const hasAccess = currentUser.accessSpec[feature];
    if (!hasAccess) {
      return <Navigate to={HOME_PAGE_URL} replace />;
    }
  }
  
  return children;
};

export default CreatorRoute;
